import { Link } from 'react-router-dom';
import Layout from '../shared/components/Layout';

const Home = () => {
  return (
    <Layout>
      <section className="content-form">
        <h1>Tarjetas de créditos</h1>
        <p className="text-center">
          Es el momento de elegir la tuya. Te ofrecemos tarjetas con beneficios
          que se adaptan a todas las necesidades, personalidades y estilos de
          vida.
        </p>
        <div className="container-action-edc">
          <Link className="action-edc" to="/datos-personales">
            <em className="bc-icon bc-md">card</em> <span>Solicitar ahora</span>
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default Home;
